export default __webpack_public_path__ + "static/media/test-results-main.f30d9429.svg";